import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { HomeIcon, LocationIcon, PackageCheckIcon } from "@/components/icons/assets";

export default function DeliveryCoverageSection() {
  return (
    <section className="py-10 sm:py-14 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-20 bg-white">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12 md:mb-16">
        <Badge variant="outline" className="font-plus-jakarta text-xs sm:text-sm font-medium text-neutral-500 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-6">
          Delivery Time & Coverage
        </Badge>
        <h2 className="font-plus-jakarta text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 mb-4 sm:mb-6">
          FAST DELIVERY<br className="hidden sm:block" /> ACROSS DENMARK
        </h2>
        <p className="font-plus-jakarta text-xs sm:text-sm md:text-base text-neutral-300 max-w-2xl mx-auto">
          We deliver wheels safely and efficiently across Denmark, with clear timelines and full tracking from dispatch to doorstep.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Left - Delivery Time Card (Large) */}
        <Card className="bg-background-50 border-none rounded-xl shadow-none lg:row-span-2 lg:h-[800px]">
          <CardContent className="p-6 sm:p-10 h-full flex flex-col justify-between">
            <div>
              <h3 className="font-plus-jakarta text-lg sm:text-xl font-bold text-neutral-900 mb-2">
                DELIVERY TIME
              </h3>
              <p className="font-plus-jakarta text-sm sm:text-base text-neutral-300 leading-relaxed max-w-[500px]">
                Most orders arrive within <span className="font-bold text-neutral-900">2-5 business days</span>, depending on shipment size and destination.
              </p>
            </div>
            <div className="flex justify-center py-8 md:py-24">
              <HomeIcon className="" />
            </div>
          </CardContent>
        </Card>

        {/* Right Top - Coverage Areas Card */}
        <Card className="bg-background-50 border-none rounded-xl shadow-none lg:h-[367px]">
          <CardContent className="p-6 sm:p-10 h-full flex flex-col justify-between gap-14">
            <div className="flex justify-center">
              <LocationIcon className="" />
            </div>
            <div>
              <h3 className="font-plus-jakarta text-lg sm:text-xl font-bold text-neutral-900 mb-2">
                COVERAGE AREAS
              </h3>
              <p className="font-plus-jakarta text-sm sm:text-base text-neutral-300 leading-relaxed max-w-[450px]">
                We deliver wheels <span className="font-bold text-neutral-900">nationwide across Denmark</span>, including urban and remote locations.
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Right Bottom - Tracking & Updates Card */}
        <Card className="bg-background-50 border-none rounded-xl shadow-none lg:h-[417px]">
          <CardContent className="p-6 sm:p-10 h-full flex flex-col justify-between gap-12">
            <div className="flex justify-center">
              <PackageCheckIcon className="" />
            </div>
            <div>
              <h3 className="font-plus-jakarta text-lg sm:text-xl font-bold text-neutral-900 mb-2">
                TRACKING & UPDATES
              </h3>
              <p className="font-plus-jakarta text-sm sm:text-base text-neutral-300 leading-relaxed max-w-[550px]">
                Track your delivery in real time with <span className="font-bold text-neutral-900">automatic status updates</span> after dispatch.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
